// extracted by mini-css-extract-plugin
export var cardLayout = "_8a-1";
export var paginationContainer = "_8a-0";